import React from 'react';
import { ProgressWithStack } from './ProgressWithStack';
import { ProgressWithValue } from './ProgressWithValue';
import { progressBlock } from './constants';
import { isProgressWithStack } from './types';
import './Progress.css';
export const Progress = React.forwardRef(function Progress(props, ref) {
    const { text = '', theme = 'default', size = 'm', loading = false, className, qa } = props;
    const resolvedProps = Object.assign(Object.assign({}, props), { text, theme, size, loading });
    return (React.createElement("div", { ref: ref, className: progressBlock({ size }, className), "data-qa": qa },
        React.createElement("div", { className: progressBlock('text') }, text),
        isProgressWithStack(resolvedProps) ? (React.createElement(ProgressWithStack, Object.assign({}, resolvedProps))) : (React.createElement(ProgressWithValue, Object.assign({}, resolvedProps)))));
});
